import React from "react"
import { Fetch } from '../../crm/function/Fetch';
import { ErrorBoundary } from "react-error-boundary";

const ErrorFallback = () => {
  return (
    <div>
      <h1>不正なエラーです</h1>
      <div>時間をおいてもう一度アクセスしてください</div>
      <button type='button' onClick={() => window.location.reload()}>画面をリロード</button>
    </div>
  );
};

export const ErrorBoundaryComp: React.FC<{}> = (props) => {
  const onError = (error: Error, info: { componentStack: string }) => {
    const fetchUrl = `/customer/api/v1/error_notifications`
    Fetch(fetchUrl, 'POST', {
      error: String(error),
      error_info: String(info),
      page: window.location.href
    })
  };

  return(
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={onError}>
      {props.children}
    </ErrorBoundary>
  ) 
}